module.exports = __webpack_public_path__ + "static/media/rounded-red-fail.e335ef25.svg";